var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-credit-card',{attrs:{"host-field-id":_vm.containerName,"title":'ת.ז.',"error-message":_vm.socialId.error,"focused":_vm.focused,"empty":_vm.socialId.isEmpty}})}
var staticRenderFns = []

export { render, staticRenderFns }